import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { IDeptartment } from "../interfaces/IDepartment";
import { ITabSetCategoriesAndHtml } from "../interfaces/ITabSetCategoryAndHtml";
import { ITabSetCategory } from "./../interfaces/ITabSetCategory";
import ApiCacheService from "./apiCacheService";
import { ApiEndpointResolver } from "./apiEndpointResolver";
import EnvironmentService from "./environmentService";
import HttpClient from "./httpClient";

function applyShareReplay<T>(observable: Observable<T>) {
  return observable.pipe(shareReplay(1));
}

let categoriesObservable: Observable<ITabSetCategory[]> | undefined;

export const WbmMainHeaderApi = {
  getCategories(): Observable<ITabSetCategory[]> {
    return categoriesObservable
      ? (categoriesObservable as Observable<ITabSetCategory[]>)
      : (categoriesObservable = applyShareReplay(
          HttpClient.get({
            baseUri: ApiEndpointResolver.getTabSetsCategoriesUrl(),
          })
        ));
  },
};

export const TabSetsService = {
  getSubCategories(
    parentCategoryId: string
  ): Observable<ITabSetCategoriesAndHtml> {
    const key = `TabSet/Categories/${parentCategoryId}`;

    return ApiCacheService.withCache(
      key,
      HttpClient.get({
        baseUri:
          ApiEndpointResolver.getTabSetsSubCategoriesUrl(parentCategoryId),
      })
    );
  },
  getCategories(): Observable<ITabSetCategory[]> {
    if (EnvironmentService.get().isEcom) {
      return HttpClient.get({
        baseUri: ApiEndpointResolver.getTabSetsCategoriesUrl(),
      });
    } else {
      return WbmMainHeaderApi.getCategories();
    }
  },
  getDepartments(): Observable<IDeptartment[]> {
    return HttpClient.get({
      baseUri: ApiEndpointResolver.getDepartmentsUrl(),
    });
  },
};
